import { useScheduleEditorReviewDecisions } from "./hooks/use-schedule-editor-review-decisions"
import { AuthoringEditorInlineRejectionBanner } from "./authoring-editor-inline-rejection-banner"

export function AuthoringEditorRejectionBanner({ amendsKey }) {
    const reviewDecisionByAmendsKey = useScheduleEditorReviewDecisions()
    const decision = reviewDecisionByAmendsKey[amendsKey]

    if (decision?.payload?.status !== "rejected") return null

    return <AuthoringEditorInlineRejectionBanner decision={decision} />
}
